import { createContext } from 'react';

const MailTemplatesContext = createContext({
    categories: { data: [], loading: false }
});

export default MailTemplatesContext;
